/**
 * A calm, full-panel notice for a page that is built but waiting on
 * something outside the app (an email account, a payment key). One
 * title, one sentence, nothing to click.
 */
export function ComingSoon({ title, body }: { title: string; body: string }) {
  return (
    <section className="mx-auto max-w-[1100px] px-5 py-8 md:px-10 md:py-12">
      <div className="surface flex min-h-[320px] flex-col items-center justify-center px-6 py-16 text-center">
        <h1 className="page-title">{title}</h1>
        <p className="mt-3 max-w-md text-[16px] leading-relaxed text-[color:var(--color-ink-soft)]">
          {body}
        </p>
      </div>
    </section>
  );
}
